import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  initializeGoogleAds,
  trackGoogleAdsPageView,
} from "../../utils/googleAds";

const GoogleAdsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    initializeGoogleAds();
  }, []);

  useEffect(() => {
    initializeGoogleAds();
    trackGoogleAdsPageView(
      `${location.pathname}${location.search}${location.hash}`
    );
  }, [location.hash, location.pathname, location.search]);

  return null;
};

export default GoogleAdsTracker;
